import { render, staticRenderFns } from "./RoomTypeDetail.vue?vue&type=template&id=1f15c9c1&"
import script from "./RoomTypeDetail.vue?vue&type=script&lang=js&"
export * from "./RoomTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports